import { createFileRoute } from "@tanstack/react-router";
import { IntegrationsApp } from "./IntegrationsApp";

export const Route = createFileRoute("/integrations/edit")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { id?: string; type?: string } => {
    const rawId = search.id;
    const id =
      rawId == null
        ? undefined
        : typeof rawId === "number"
          ? String(rawId)
          : typeof rawId === "string"
            ? rawId.replace(/^"|"$/g, "").trim()
            : undefined;
    const type =
      typeof search.type === "string" ? search.type.trim() : undefined;
    return { id: id || undefined, type: type || undefined };
  },
  component: EditIntegrationPage,
});

function EditIntegrationPage() {
  return <IntegrationsApp />;
}
